import { propOr } from '@seedcloud/ramda-extra'

import { FieldGroup, Row, TextField } from 'components/company/common'

const CommercialContact = ({ title, commercial }) => (
  <FieldGroup title={title}>
    <Row>
      <TextField
        label="First Name"
        value={propOr(null, 'firstName', commercial)}
        name="commercial.firstName"
        required
      />
      <TextField
        label="Last Name"
        value={propOr(null, 'lastName', commercial)}
        name="commercial.lastName"
        required
      />
    </Row>
    <Row>
      <TextField
        label="Phone"
        value={propOr(null, 'phoneNumber', commercial)}
        name="commercial.phoneNumber"
        required
      />
      <TextField
        label="Email"
        value={propOr(null, 'email', commercial)}
        name="commercial.email"
        required
      />
    </Row>
  </FieldGroup>
)

export { CommercialContact }
